<template>
  <el-dialog :title="content.title" :visible.sync="visible" :close-on-click-modal="false" width="80%">
    <el-form ref="form" label-position="top" label-width="150px" :model="form">
      <el-row :gutter="20">
        <el-col :span="16">
          <el-tabs type="border-card">
            <el-tab-pane label="Contenu de la facture">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Société émettrice">
                    <el-select class="form-control" :value="1" placeholder="Select">
                      <el-option :key="1" label="Com Web" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Société réceptrice">
                    <customer-select :id="item.customer_id"></customer-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <p style="text-align: center; margin: 100px 0;">Détail de la facture</p>
              </el-row>
              <el-row :gutter="20">
                <el-col :offset="16" :span="8">
                  <el-form-item prop="amount_total_no_vat" label="Total HT">
                    <el-input v-model="form.amount_total_no_vat">
                      <template slot="append">€ HT</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="amount_total" label="Total TTC">
                    <el-input v-model="form.amount_total">
                      <template slot="append">€ TTC</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="8">
          <el-tabs type="border-card">
            <el-tab-pane label="Options de facture">
              <el-form-item prop="user_id" label="Interlocuteur">
                <user-select :id="form.user_id"></user-select>
              </el-form-item>
              <el-form-item prop="deadline_at" label="Date limite de paiement">
                <el-date-picker class="form-control" v-model="form.deadline_at" type="date" placeholder="Choisissez une date"></el-date-picker>
              </el-form-item>
              <el-form-item prop="litigation_at" label="Date limite de recouvrement">
                <el-date-picker class="form-control" v-model="form.litigation_at" type="date" placeholder="Choisissez une date"></el-date-picker>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-on:click="visible = false">Annuler</el-button>
      <el-button :type="content.button_type" v-on:click="submit(false)" :loading="loading">{{ content.button }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import CustomerSelect from '../Entities/Selects/CustomerSelect.vue'
  import UserSelect from '../Entities/Selects/UserSelect.vue'

  export default {
    components: {
      UserSelect,
      CustomerSelect
    },
    name: 'invoice-modal',
    data () {
      return {
        visible: false,
        loading: false,
        content: {
          title: '',
          button: '',
          button_type: ''
        },
        item: {},
        form: {
          id: null,
          amount_total_no_vat: '',
          amount_total: '',
          deadline_at: '',
          litigation_at: '',
          user_id: ''

          // TODO : fill properties here
        }
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      }
    },
    mounted () {
      let self = this

      this.$model.invoice.on('create', () => {
        self.content.title = 'Création d\'une facture'
        self.content.button = 'Créer la facture'
        self.content.button_type = 'success'

        self.visible = true
      })

      this.$model.invoice.on('edit', ({item}) => {
        self.content.title = 'Modification d\'une facture'
        self.content.button = 'Modifier la facture'
        self.content.button_type = 'warning'

        self.load(item)

        self.visible = true
      })
    },
    methods: {
      handleCustomerChange (value) {
        console.log(value)
      },
      reset () {
        this.form = this.$options.data.apply(this).form
        this.$refs['form'].resetFields()
      },
      load (item) {
        if (item) {
          this.item = item
          if (item.id) this.form.id = item.id
          if (item.amount_total_no_vat) this.form.amount_total_no_vat = item.amount_total_no_vat
          if (item.amount_total) this.form.amount_total = item.amount_total
          if (item.deadline_at) this.form.deadline_at = item.deadline_at
          if (item.litigation_at) this.form.litigation_at = item.litigation_at
          if (item.user_id) this.form.user_id = item.user_id

          // TODO : Fill properties here
        }
      },
      submit () {
        let self = this

        this.$refs['form'].validate((valid) => {
          if (valid) {
            let p

            if (this.form.id === null) {
              p = self.$model.invoice.api().create(this.form)
            } else {
              p = self.$model.invoice.api().update(this.form.id, this.form)
            }

            p.then(() => {
              self.visible = false
            })
          } else {
            self.$message.error('Impossible de valider le formulaire. Merci de vérifier les valeurs saisies')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InvoiceModal.vue?fb5e8b1a